import {bufferTime, catchError, distinct, filter, first, groupBy, map, mapTo, mergeMap, tap} from "rxjs/operators";
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  API_GET_PUNCH_LIST,
  API_GET_PUNCH_LIST_DONE,
  API_GET_PUNCH_LISTS,
  API_GET_PUNCH_LISTS_DONE,
  getPunchListDone,
  getPunchLists,
  getPunchListsDone
} from "../actions/punchList";
import * as R from 'ramda';
import {getPunches$, getPunchesMulti$} from "../services/projects";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {injectSubview, setSubview, setSubviewCache} from "../actions/view";

const SVCLF = setSubviewCache({ loading: false });

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LIST),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: true })),
  catchErrorsandResume(20040)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LIST_DONE, API_GET_PUNCH_LISTS_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: false })),
  catchErrorsandResume(20041)
);

const getSingleEpic = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LIST),
  mergeMap(action => getPunches$({ id: action.payload.id, projectId: action.payload.projectId }).pipe(
    map(({response}) => getPunchListDone(response)),
    catchError(error => of(SVCLF, networkError({...error, number: '10090-'+error.status})))
  )),
  catchErrorsandResume(20044)
);

const getSingleEpicMulti = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LIST),
  groupBy(action => action.payload.projectId),
  mergeMap(group$ => group$.pipe(
    distinct(action => action.payload.id, requestDedupInterval$),
    bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
    filter(actions => actions.length > 0),
    mergeMap(actions => getPunchesMulti$({ projectId: actions[0].payload.projectId, ids: actions.map(action => action.payload.id )}).pipe(
      filter(({ response }) => response && response['results']),
      map(({ response }) => setSubview(response.results)),
      catchError(error => of(SVCLF, networkError({...error, number: '10091-'+error.status})))
    )),
    catchError(error => of(SVCLF, networkError({...error, number: '10092-'+error.status}))),
  )),
  catchErrorsandResume(20045)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LIST_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(punchLists => punchLists[0].callback && punchLists[0].callback(punchLists[0].response.resource.id)),
  map(results => results.map(punchList => punchList.response)),
  map(results => setSubview(results)),
  catchErrorsandResume(20047)
);

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LISTS),
  mergeMap(action => getPunches$({ id: action.payload.id, projectId: action.payload.projectId, offset: action.payload.offset }).pipe(
    map(({response}) => getPunchListsDone(response)),
    catchError(error => of(SVCLF, networkError({...error, number: '10093-'+error.status})))
  )),
  catchErrorsandResume(20043)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LISTS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => injectSubview(results)),
  catchErrorsandResume(20046)
);

const getMoreEpic = action$ => action$.pipe(
  ofType(API_GET_PUNCH_LISTS_DONE),
  filter(action => action.payload && action.payload.results && action.payload.results.length === action.payload.limit),
  map(action => getPunchLists(action.payload.results.slice(-1)[0].resource.projectid, action.payload.results.slice(-1)[0].resource.id)),
  catchErrorsandResume(20042)
);

export const punchListEpic = combineEpics(
  beginLoading,
  endLoading,
  // getSingleEpic,
  getSingleEpicMulti,
  processSingleEpic,
  getMultipleEpic,
  processMultipleEpic,
  getMoreEpic
);



// WEBPACK FOOTER //
// ./src/network/punchList.js